import { HiOutlineLogout } from 'react-icons/hi'
import { useAuthProvider } from '../../modules/Auth/providers/AuthSupabaseProvider/AuthProvider.hook'
import { Logout as LogoutButton } from './Logout.styles'

const Logout = () => {
  const { logout, signingOut } = useAuthProvider()

  const handleLogout = () => {
    if (signingOut) return
    logout()
  }

  return (
    <LogoutButton
      type="button"
      onClick={handleLogout}
      disabled={signingOut}
      aria-busy={signingOut}
    >
      <HiOutlineLogout size={16} aria-hidden />
      {signingOut ? 'Cerrando sesión…' : 'Cerrar sesión'}
    </LogoutButton>
  )
}

export default Logout
